import { render, staticRenderFns } from "./f.vue?vue&type=template&id=6bbcae54&scoped=true&"
import script from "./f.vue?vue&type=script&lang=js&"
export * from "./f.vue?vue&type=script&lang=js&"
import style0 from "./f.vue?vue&type=style&index=0&id=6bbcae54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbcae54",
  null
  
)

export default component.exports